import { handleEmbeds } from './embed/index.jsx';
import { SeasonalEvents } from './events/index.js';
import { Christmas2019EventInfo } from './events/christmas2019.js';
import { element, fragment } from './html.js';
import hljs from 'highlight.js';
import { updateHeaderMessageCounter } from './messages/header.jsx';
import { initTimingsOverlay } from './perf.jsx';
import { trackTimeElements } from './relatime.js';
import { initXhrActions, initXhrForms } from './xhra.js';

// make these globally available for JSX
Object.defineProperty(window, '$element', { value: element });
Object.defineProperty(window, '$fragment', { value: fragment });

initTimingsOverlay();

window.addEventListener('DOMContentLoaded', function() {
    initXhrActions();
    initXhrForms();
    trackTimeElements();

    updateHeaderMessageCounter();

    const events = new SeasonalEvents;
    events.add(new Christmas2019EventInfo);
    events.dispatch();

    hljs.highlightAll();

    handleEmbeds(document.querySelectorAll('.js-msz-embed-media'));
});
